import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.es'
import yieldLadder from './yieldLadder.es'

export default createLendingBundle({ whitepaper, yieldLadder })
